export default "__VITE_ASSET__D8AvRfa2__"